function sgModalOpen() {
  var o = document.getElementById('sg-modal-overlay');
  if (!o) return;
  o.classList.add('is-open');
  o.setAttribute('aria-hidden', 'false');
  document.body.classList.add('sg-modal-open');
  o.addEventListener('click', _sgOverlayClick);
  document.addEventListener('keydown', _sgEscKey);
}

function sgModalClose() {
  var o = document.getElementById('sg-modal-overlay');
  if (!o) return;
  o.classList.remove('is-open');
  o.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('sg-modal-open');
  o.removeEventListener('click', _sgOverlayClick);
  document.removeEventListener('keydown', _sgEscKey);
}

function _sgOverlayClick(e) {
  if (e.target === document.getElementById('sg-modal-overlay')) sgModalClose();
}

function _sgEscKey(e) {
  if (e.key === 'Escape') sgModalClose();
}